import TextAreaBasic from './TextAreaBasic'
import TextAreaNormal from './TextAreaNormal'
import TextAreaPrimary from './TextAreaPrimary'

const TextArea = {
  Basic: TextAreaBasic,
  Normal: TextAreaNormal,
  Primary: TextAreaPrimary,
}

export default TextArea
